<template>
	<div class="body">
		<div class="body-container">

			<div class="right-content">
				<div class="content-title" v-if="title">
					<img class="title-wing" src="../../assets/icons/title_wing_left.png" />
					<span class="title-text">{{title}}</span>
					<img class="title-wing" src="../../assets/icons/title_wing_right.png" />
				</div>

				<div class="match-ctr">
					<div class="login-ctr" v-if="hasLogin == 2">
						<div class="login-tips">该功能需要登录后才能使用</div>
						<el-button class="to-login" type="primary" icon="el-icon-s-custom"
							@click="clickLogin">点击登录</el-button>
					</div>
					<template v-else-if="hasLogin == 1">
						<div class="match-create-ctr">
							<el-button type="primary" icon="el-icon-plus" size="medium"
								@click="createUserMatch()">新建</el-button>
						</div>
						<el-table border :data="dataList">
							<el-table-column label="学历" align="center" prop="degree" min-width="1" />
							<el-table-column label="专业大类" align="center" prop="start_year" min-width="1">
								<template v-slot="{ row }">
									<label>{{row.majorTop.name}}</label>
								</template>
							</el-table-column>
							<el-table-column label="开始年份" align="center" prop="start_year" min-width="1" />
							<el-table-column label="结束年份" align="center" prop="end_year" min-width="1" />
							<el-table-column label="日期" align="center" prop="created_at" min-width="1" />
							<el-table-column label="操作" align="center" prop="province_name" min-width="2">
								<template v-slot="{ row }">
									<el-button type="primary" icon="el-icon-reading" size="medium"
										class="el-button--success" @click="clickMatch(row)">查看</el-button>

									<el-button type="primary" icon="el-icon-delete" size="medium"
										class="el-button--danger" @click="clickDel(row)">删除</el-button>
								</template>
							</el-table-column>
						</el-table>

					</template>


				</div>


			</div>
		</div>

		<el-dialog :visible.sync="showMatchDialog" title="新建三次产偏离度分析" align='center'>
			<div class="create-group-ctr">
				<div class="group-row">
					<label>学历</label>
					<el-select class="group-select" v-model="degree" placeholder="请选择" @change="changeDegree">
						<el-option v-for="item in degreeList" :key="item.name" :label="item.name"
							:value="item.name">
						</el-option>
					</el-select>
				</div>
				
				<div class="group-row">
					<label>专业大类</label>
					<el-select class="group-select" v-model="major" placeholder="请选择" :clearable=true filterable>
						<el-option v-for="item in majorList" :key="item.code" :label="item.name"
							:value="item.code">
						</el-option>
					</el-select>
				</div>

				<div class="group-row">
					<label>开始年份</label>
					<el-select class="group-select" v-model="start_year" placeholder="请选择" :clearable=true>
						<el-option v-for="item in yearList" :key="item" :label="item" :value="item">
						</el-option>
					</el-select>
				</div>
				
				<div class="group-row">
					<label>结束年份</label>
					<el-select class="group-select" v-model="end_year" placeholder="请选择" :clearable=true>
						<el-option v-for="item in yearList" :key="item" :label="item" :value="item">
						</el-option>
					</el-select>
				</div>
			</div>

			<div slot="footer" class="dialog-footer" align="center">
				<el-button type="primary" @click="confirmCreateMatch()">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		createFit,
		getFitList,
		deleteFit,
		getFitConfig,
		getDegreeMajorTopList
	} from "@/api/service"

	import {
		getAddrTree,
		exportGroupJobData
	} from "@/api/matrix"

	import {
		isEmpty,
		setLocalData,
		getLocalData
	} from "@/utils/util"

	import {
		useLoginStore
	} from "@/utils/login"

	import {
		Notification,
		Message,
		Loading
	} from 'element-ui'

	import {
		parse,
		handleProtocal,
		handleRouteProtocal
	} from "@/utils/protocal"

	export default {
		name: "Service",
		data() {
			return {
				name: '',
				dataList: [],
				degreeList: null,
				majorList: [],
				degree: '',
				showMatchDialog: false,
				year: '',
				hasLogin: 3,
				major: '',
			
				queryParams: {
					page: 1,
					pageSize: 20
				},
				title: '',
				start_year: 0,
				end_year: 0,
				areaList: [],
				addrList: [],
				yearList: []
			}
		},

		setup() {
			const loginStore = useLoginStore()

			// 返回 store 到模板中使用
			return {
				loginStore
			}
		},

		created() {
			this.initPageData();
		},
		methods: {
			initPageData() {
				this.requestMajorMatchList();
				this.loadConfig();
			},
			
			requestMajorMatchList(){
				getFitList(this.buildParams()).then(res => {
					this.hasLogin = res.data.hasLogin;
					if (this.hasLogin == 1) {
						this.dataList = res.data.list;
						this.total = res.data.pageData.totalCount;
						this.title = res.data.title;
					}
				});
			},
			
			changeDegree(type){
				let params = {
					'degree': type
				}
				this.majorList = '';
				this.major = '';
				getDegreeMajorTopList(params).then(res => {
					this.majorList= res.data.list;
				})
			},
			
			loadConfig() {
				getFitConfig().then(res => {
					this.yearList = res.data.yearList;
					this.degreeList = res.data.degreeList;
				});
			},
			

			buildParams() {
				this.queryParams['start_year'] = this.start_year;
				this.queryParams['end_year'] = this.end_year;
				this.queryParams['degree'] = this.degree;
				this.queryParams['top_code'] = this.major;
				return this.queryParams;
			},


			clickRoute(item) {
				console.log('item', item)
				let data = parse(item.url)

				if (data['head'] == 'replace') {
					let url = "/" + data['path'];
					if (data['data'] != null && data['data'].length != 0) {
						url += "?" + data['data'];
					}
					console.log('url', url)
					// this.$router.replace(url);
					this.$router.push(url);
				} else {
					handleRouteProtocal(data)
				}
			},

			//-----------match----------	

			createUserMatch() {
				this.degree = '';
				this.start_year = '';
				this.end_year = '';
				this.major = '';
				this.showMatchDialog = true;
			},

			confirmCreateMatch() {
				createFit(this.buildParams()).then(res => {
					this.showMatchDialog = false;
					this.requestMajorMatchList();
				})
			},

			clickMatch(row) {
				let path = '/fit_enroll?id=' + row.id;
				this.$router.push(path);
			},

			clickDel(row) {
				this.$modal.confirm('确定要删除该条数据吗？').then(() => {
					deleteFit({
						'id': row.id
					}).then(res => {
						this.requestMajorMatchList();
					})
				})
			},

			clickLogin() {
				this.loginStore.openLoginDialog()
			}

		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	@use "fit_index.scss";
</style>